export default {
  rentals: "rentals",
  sales: "sales"
};
